import CrudRepository from './CrudRepository'
import Repository from './Repository'
export default class SegmentBundleById extends CrudRepository {
  constructor (id) {
    super(`/core/api/segment-bundles/details/${id}/web`)
  }

  async getBundleDetails () {
    const data = await Repository.get(`${this.resource}`)
    return data.data
  }
}
